// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
declare global {
  interface Window {
    jQuery: typeof jQuery;
  }
}

require('@rails/ujs').start();
const jQuery = require('jquery/dist/jquery.js');
// can use jQuery in global
window.jQuery = jQuery;
require('popper.js/dist/popper.js');
require('bootstrap/dist/js/bootstrap');
require('bootstrap/dist/css/bootstrap');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.ja');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker');

import 'formdata-polyfill';
import 'viewerjs/dist/viewer.css';
import 'cropperjs/dist/cropper.css';

import './staff/common/adjust_height';
import './staff/common/display_chrome_recommended_banner';
import './staff/common/datepicker';
import './staff/common/toggle_help';
import './staff/common/search_form/stores_for_query';
import './staff/common/store_bulk_import';
import './staff/common/error_detection';
import './staff/common/form/emoji_validation';
import './staff/common/page_transition';
import './staff/common/header';
import './staff/common/karte_identify';
import './staff/common/help_link_karte_event'
import './staff/common/sidebar_menu'
import './staff/common/progress_modal'

import './staff/leaflets/new';
import './staff/leaflets/edit';
import './staff/leaflets/index';
import './staff/leaflets/bulk_new';
import './staff/leaflets/edit_recommend_ingredients';
import './staff/coupons/form';
import './staff/coupons/index';
import './staff/store_groups/form';
import './staff/store_groups/new';
import './staff/store_groups/edit';
import './staff/store_products/new';
import './staff/store_products/edit';
import './staff/store_products/index';
import './staff/store_products/form';
import './staff/store_products/product_image_and_image_gallery_form';
import './staff/store_products/bulk_new';
import './staff/store_products/bulk_confirmation';
import './staff/store_products/product_image_crop_for_form';
import './staff/notification_images/new';
import './staff/store_notifications/index';
import './staff/store_notifications/new';
import './staff/store_notifications/edit';
import './staff/recipe_cards/download';
import './staff/promotional_materials/index'
import './staff/leaflet_bulk_imports/bulk_new'
import './staff/leaflet_bulk_imports/index'
import './staff/feature_authority_staff_accounts/bulk_edit'
import './staff/staff_store_group_relationships/bulk_edit'
import './staff/sessions/logged_in'
import './staff/sessions/logged_out'
import './staff/staffs/new'
import './staff/staffs/edit'
import './staff/accounts/edit'
import './staff/leaflet_publish_settings/new'
import './staff/stores/edit'
import './staff/gbp/common/error_message'
import './staff/gbp/locations/index'
import './staff/gbp/locations/edit'
import './staff/gbp/local_posts/index'
import './staff/stores/bulk_update_confirm'
import './staff/gbp/reviews/index'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
